/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import SystemCollection from '@/classes/SystemCollection';
import _ from 'lodash';

// initial state
const state = {
  versions: {},
  showLicense: false,
  licenseData: null,

  shortTitle: true,
};

// getters
const getters = {
  rootRecordTitle(state) {
    let title = 'Info';

    const entry = _.find(state.versions, item => item && item.details && item.details.root);

    if (entry && entry.version) {
      title = `${title} v.${entry.version}`;
      if (entry.hash && !state.shortTitle) title += ` (${entry.hash})`;
    }

    return title;
  },
};

// actions
const actions = {
  version: SystemCollection.actions.version,
  getLicense: SystemCollection.actions.getLicense,

  async fetchVersions({ dispatch, commit }) {
    const versions = await dispatch('version', { __native: true });
    const resVersions = _.get(versions, 'data', {});
    commit('setVersions', resVersions);
    return resVersions;
  },

  async fetchLicense({ commit, dispatch }) {
    try {
      const resp = await dispatch('getLicense', {});
      if (resp && resp.data) {
        commit('setLicenseData', resp.data);
      }
    } catch (err) {
      commit('setLicenseData', null);
    }
  },

  openLicenseDialog({ commit }) {
    commit('setShowLicense', true);
  },
  closeLicenseDialog({ commit }) {
    commit('setShowLicense', false);
  },

  changeTitle({ commit }) {
    commit('toggleShortTitle');
  },
};

// mutations
const mutations = {
  setVersions(state, versions) {
    state.versions = versions;
  },
  setShowLicense(state, value) {
    state.showLicense = value;
  },
  setLicenseData(state, data) {
    state.licenseData = data;
  },
  toggleShortTitle(state, data) {
    state.shortTitle = !state.shortTitle;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
